export interface HotItem {
  id: number;
  category: string;
  categoryKey: string;
  tag: string;
  title: string;
  excerpt: string;
  image: string;
  time: string;
  heat: number;
  hot: boolean;
}

export interface RankingItem {
  id: number;
  title: string;
  value: string;
  trend: 'up' | 'down' | 'new';
  hotTag: string;
}

export interface FeatureItem {
  id: number;
  tag: string;
  title: string;
  excerpt: string;
  image: string;
  readTime: string;
}

export interface CategoryItem {
  key: string;
  name: string;
  icon: string;
  desc: string;
  count: string;
  hot: string;
}

export interface TickerItem {
  label: string;
  text: string;
}

export const categories: CategoryItem[] = [
  { key: 'star', name: '明星娱乐', icon: 'ri-star-smile-line', desc: '顶流动向、片约花边与私生活新料，明星头条一手掌握', count: '今日+126', hot: '128万' },
  { key: 'show', name: '综艺八卦', icon: 'ri-mic-line', desc: '录制现场、名场面与剪辑修罗场，综艺里的真实瓜', count: '今日+98', hot: '96万' },
  { key: 'live', name: '直播网红', icon: 'ri-live-line', desc: '头部主播翻车、品牌风波与电商圈大瓜速报', count: '今日+143', hot: '182万' },
  { key: 'society', name: '社会热点', icon: 'ri-flashlight-line', desc: '刷屏事件与公共议题，理性吃瓜看清来龙去脉', count: '今日+75', hot: '76万' },
  { key: 'meme', name: '网络爆梗', icon: 'ri-emotion-laugh-line', desc: '神曲热梗、疯传名场面，今天全网在玩什么', count: '今日+201', hot: '214万' },
  { key: 'deep', name: '深度解析', icon: 'ri-search-line', desc: '不止于瓜，梳理事件时间线与背后的门道', count: '今日+32', hot: '45万' },
];

export const tickerItems: TickerItem[] = [
  { label: '突发', text: '某头部主播深夜直播道歉，承认选品失察，评论区瞬间刷屏' },
  { label: '热播', text: '年度黑马综艺收官夜名场面冲上热搜，弹幕炸出全场最高热度' },
  { label: '爆料', text: '网友拍下顶流现身片场被围堵，工作室暂未回应' },
  { label: '爆梗', text: '一句方言神曲在短视频平台一夜爆火，翻唱版本已超百万' },
  { label: '突发', text: '品牌发布声明回应合作争议，网友争相解读公关话术' },
  { label: '热评', text: '年度红毯造型盘点出炉，网友票选「最佳现场」结果揭晓' },
];

export const featured: HotItem = {
  id: 1,
  category: '明星娱乐',
  categoryKey: 'star',
  tag: '独家首发',
  title: '「塌房」一年后，那位曾经的顶流首次公开亮相，现场反应刷屏全网',
  excerpt: '沉寂许久的名字重新回到聚光灯下，短短三分钟的现身视频在社交平台被疯转，弹幕里既有老粉的感慨，也有路人的围观。业内人士透露，这或许只是复出前的一次试水。',
  image: 'https://readdy.ai/api/search-image?query=editorial%20magazine%20collage%20of%20a%20spotlight%20on%20an%20empty%20red%20stage%20with%20paparazzi%20flash%20lights%20and%20crowd%20silhouettes%2C%20warm%20amber%20and%20vermilion%20orange%20palette%2C%20dramatic%20cinematic%20lighting%2C%20textured%20paper%20background%2C%20high%20contrast%2C%20no%20text&width=1200&height=800&seq=hero-main-01&orientation=landscape',
  time: '12 分钟前',
  heat: 2180000,
  hot: true,
};

export const heroSide: HotItem[] = [
  {
    id: 2,
    category: '综艺八卦',
    categoryKey: 'show',
    tag: '实锤',
    title: '综艺名场面被考古出「剧本痕迹」，制片人深夜发文回应',
    excerpt: '网友逐帧对比节目画面，矛头直指剪辑逻辑，话题阅读量一小时破千万。',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20television%20studio%20control%20desk%20with%20many%20monitors%20showing%20blurred%20stage%20scenes%2C%20warm%20amber%20and%20orange%20tones%2C%20cinematic%20moody%20lighting%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=side-02&orientation=landscape',
    time: '35 分钟前',
    heat: 960000,
    hot: true,
  },
  {
    id: 3,
    category: '直播网红',
    categoryKey: 'live',
    tag: '翻车',
    title: '千万粉丝直播间被曝「演戏式砍价」，当场有网友录屏喊停',
    excerpt: '镜头前声嘶力竭的砍价背后，被扒出标价与历史价格存在出入，风波仍在发酵。',
    image: 'https://readdy.ai/api/search-image?query=live%20streaming%20studio%20desk%20with%20phone%20on%20tripod%2C%20ring%20light%20glow%2C%20product%20boxes%20and%20price%20tags%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=side-03&orientation=landscape',
    time: '58 分钟前',
    heat: 1180000,
    hot: true,
  },
  {
    id: 4,
    category: '网络爆梗',
    categoryKey: 'meme',
    tag: '爆火',
    title: '新一季「全民二创」开场，改编版本 24 小时破百万播放',
    excerpt: '从鬼畜到深情翻唱，一句歌词被玩出百种花样，成为本周最快破圈内容。',
    image: 'https://readdy.ai/api/search-image?query=phone%20screen%20with%20colorful%20music%20waveform%20and%20play%20button%20on%20wooden%20desk%20next%20to%20headphones%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=side-04&orientation=landscape',
    time: '2 小时前',
    heat: 2140000,
    hot: true,
  },
];

export const feedList: HotItem[] = [
  {
    id: 5,
    category: '明星娱乐',
    categoryKey: 'star',
    tag: '八卦',
    title: '机场偶遇照疯传，造型师无意曝出「下一部戏」关键词',
    excerpt: '一组看似随意的机场街拍，却让粉丝从配饰细节里扒出合作线索，讨论热度直线上升。',
    image: 'https://readdy.ai/api/search-image?query=airport%20terminal%20with%20a%20traveller%20silhouette%20walking%20with%20rolling%20luggage%20and%20sunlight%20through%20glass%20roof%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=feed-05&orientation=landscape',
    time: '3 小时前',
    heat: 452000,
    hot: false,
  },
  {
    id: 6,
    category: '社会热点',
    categoryKey: 'society',
    tag: '突发',
    title: '景区「排队大战」视频刷屏，管理方连夜调整分流方案',
    excerpt: '一段游客排队纠纷的现场视频点燃舆论，景区当天即公布整改措施并公开致歉。',
    image: 'https://readdy.ai/api/search-image?query=scenic%20tourist%20crowd%20queuing%20at%20a%20mountain%20entrance%20in%20warm%20morning%20light%2C%20people%20silhouettes%2C%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=feed-06&orientation=landscape',
    time: '4 小时前',
    heat: 688000,
    hot: true,
  },
  {
    id: 7,
    category: '直播网红',
    categoryKey: 'live',
    tag: '风波',
    title: '「全媒体直播节」落幕，多位主播却被点名成交数据存疑',
    excerpt: '热闹的销售战报背后，第三方监测机构晒出脱水数据，引发圈内新一轮讨论。',
    image: 'https://readdy.ai/api/search-image?query=stage%20banner%20backdrop%20with%20confetti%20and%20spotlight%20at%20a%20sales%20event%2C%20warm%20amber%20orange%20palette%2C%20cinematic%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=feed-07&orientation=landscape',
    time: '5 小时前',
    heat: 532000,
    hot: false,
  },
  {
    id: 8,
    category: '网络爆梗',
    categoryKey: 'meme',
    tag: '热梗',
    title: '「城市方言挑战」意外出圈，官方账号下场参与玩梗',
    excerpt: '一场由普通网友发起的方言模仿挑战，竟把文旅账号都带了进来，形成全网接力。',
    image: 'https://readdy.ai/api/search-image?query=colorful%20city%20skyline%20at%20sunset%20with%20speech%20bubbles%20concept%20floating%20overhead%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20illustration%2C%20no%20text&width=800&height=500&seq=feed-08&orientation=landscape',
    time: '6 小时前',
    heat: 1260000,
    hot: true,
  },
  {
    id: 9,
    category: '综艺八卦',
    categoryKey: 'show',
    tag: '名场面',
    title: '推理综艺高能反转夜，观众投票刷新三季以来纪录',
    excerpt: '当「嫌疑人」在最后时刻被全票推翻，现场与弹幕同时沸腾，节目组宣布加更花絮。',
    image: 'https://readdy.ai/api/search-image?query=dimly%20lit%20game%20studio%20room%20with%20large%20clue%20board%2C%20cards%20and%20mystery%20atmosphere%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=feed-09&orientation=landscape',
    time: '8 小时前',
    heat: 759000,
    hot: true,
  },
  {
    id: 10,
    category: '明星娱乐',
    categoryKey: 'star',
    tag: '回应',
    title: '被拍到深夜聚餐后，工作室两字回应「清者自清」',
    excerpt: '一张聚餐照引发无限联想，粉丝与路人各执一词，话题在热搜上反复横跳。',
    image: 'https://readdy.ai/api/search-image?query=restaurant%20dinner%20table%20with%20warm%20candle%20light%20and%20blurred%20people%20silhouettes%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=feed-10&orientation=landscape',
    time: '9 小时前',
    heat: 610000,
    hot: false,
  },
  {
    id: 11,
    category: '深度解析',
    categoryKey: 'deep',
    tag: '观察',
    title: '从「翻车到道歉」只要三小时：当代热点公关的套路全拆解',
    excerpt: '我们梳理了今年几个典型事件的时间线，看看舆论场上的那句道歉到底有几分真诚。',
    image: 'https://readdy.ai/api/search-image?query=news%20desk%20with%20newspapers%20and%20magnifying%20glass%20on%20warm%20wooden%20table%2C%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=feed-11&orientation=landscape',
    time: '12 小时前',
    heat: 328000,
    hot: false,
  },
  {
    id: 12,
    category: '社会热点',
    categoryKey: 'society',
    tag: '辟谣',
    title: '「某平台要关停」传闻疯传半日后，官方下场一纸澄清',
    excerpt: '一张来源不明的截图让网友慌了神，官方连夜回应，提醒大家勿轻信小道消息。',
    image: 'https://readdy.ai/api/search-image?query=smartphone%20with%20chat%20app%20and%20warning%20notification%20on%20desk%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photo%2C%20no%20text&width=800&height=500&seq=feed-12&orientation=landscape',
    time: '14 小时前',
    heat: 485000,
    hot: false,
  },
];

export const ranking: RankingItem[] = [
  { id: 1, title: '顶流复出首现身现场刷屏', value: '318万', trend: 'new', hotTag: '爆' },
  { id: 2, title: '直播「演戏式砍价」被扒价格', value: '286万', trend: 'up', hotTag: '爆' },
  { id: 3, title: '综艺名场面考古出剧本痕迹', value: '241万', trend: 'up', hotTag: '热' },
  { id: 4, title: '城市方言挑战全民接力', value: '198万', trend: 'new', hotTag: '热' },
  { id: 5, title: '红毯造型票选「最佳现场」揭晓', value: '165万', trend: 'up', hotTag: '热' },
  { id: 6, title: '深夜聚餐照引发工作室回应', value: '143万', trend: 'down', hotTag: '热' },
  { id: 7, title: '黑马综艺收官名场面冲上热搜', value: '122万', trend: 'up', hotTag: '温' },
  { id: 8, title: '景区排队纠纷视频点燃舆论', value: '98万', trend: 'down', hotTag: '温' },
];

export const features: FeatureItem[] = [
  {
    id: 1,
    tag: '特写',
    title: '那个被「全网追杀」的普通人，后来怎么样了',
    excerpt: '每一个大瓜背后，都有一个被迫站上风口浪尖的当事人。我们花了一周时间，去回访几个曾在一夜之间被顶上热搜的名字，记录他们在那 72 小时里的真实处境，以及风波散去后如何回到生活。',
    image: 'https://readdy.ai/api/search-image?query=a%20person%20seen%20from%20behind%20standing%20at%20a%20window%20in%20soft%20warm%20morning%20light%2C%20contemplative%2C%20warm%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20portrait%20photography%2C%20no%20text&width=800&height=1000&seq=feature-13&orientation=portrait',
    readTime: '15 分钟深度',
  },
  {
    id: 2,
    tag: '调查',
    title: '一场「全民二创」是如何被点燃的：从首发到刷屏的 48 小时',
    excerpt: '你以为的火爆只是一夜之间？我们回溯了那只神曲爆火的完整链路：谁第一个发布、如何被大号转发、官方怎样下场玩梗，拆解一次典型热梗传播的每一步。',
    image: 'https://readdy.ai/api/search-image?query=flat%20lay%20of%20viral%20media%20items%20smartphone%20headphones%20vinyl%20and%20sketch%20notes%20on%20warm%20wooden%20desk%2C%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photography%2C%20no%20text&width=800&height=1000&seq=feature-14&orientation=portrait',
    readTime: '12 分钟调查',
  },
  {
    id: 3,
    tag: '观察',
    title: '娱乐圈公关话术「进化论」：从删帖到「共创式洗白」',
    excerpt: '当舆论场的规则被一次次刷新，明星团队应对危机的方式也在悄然改变。我们整理了近年的典型回应样本，看看那句「下次一定」背后藏着怎样的传播心机。',
    image: 'https://readdy.ai/api/search-image?query=open%20notebook%20with%20handwritten%20strategy%20notes%20and%20coffee%20cup%20on%20desk%20under%20warm%20lamp%20light%2C%20amber%20and%20orange%20cinematic%20tones%2C%20editorial%20photography%2C%20no%20text&width=800&height=1000&seq=feature-15&orientation=portrait',
    readTime: '18 分钟观察',
  },
];

export const testimonials = [
  { name: '一只毛豆', role: '资讯站老读者', text: '这里追热点是真的快，别家还没反应过来，吃瓜热点已经放出前后经过的整理帖了，信息很有条理。' },
  { name: '阿远', role: '吃瓜十级学者', text: '最难得的是不为了流量乱带节奏，很多「大瓜」发出来都会标注时间线和已知信息，理性成分我很欣赏。' },
  { name: 'Momo酱', role: '短视频运营', text: '做内容的日常就是泡在这里找素材，分类清楚、梗源及时，灵感枯竭了就上来刷一刷，基本不会空手而归。' },
  { name: '南方以南', role: '普通读者', text: '晚上睡觉前看几篇热榜总结，第二天跟同事聊天完全不掉队，页面读起来也不累，排版我很喜欢。' },
];

export const faqList = [
  {
    q: '吃瓜热点的「突发瓜」一般多久更新一次？',
    a: '热点栏目全天滚动更新，遇到刷屏级事件通常会在 10 到 30 分钟内整理发布「快讯」，随后逐步补充时间线与各方回应。你可以在顶部快讯栏或「猛料大厅」按时间刷到最新动态。',
  },
  {
    q: '怎么区分「实锤」「爆料」和「传闻」？',
    a: '我们会为每一条内容打上可信度标签：「实锤」指有官方回应或多方交叉信源印证；「爆料」指有当事人/在场者描述但尚未完全证实；「传闻」则多为二手截图或单方面说法，仅作线索呈现，并会持续跟进进展。',
  },
  {
    q: '内容是从哪里来的？会转载吗？',
    a: '内容由编辑部持续监测全网公开信息（官方声明、正规媒体报道、多方信源）整理而成。转载内容会注明出处并附原文链接，原创分析与深度报道则以「特写」「观察」栏目单独呈现。',
  },
  {
    q: '看到不实信息或侵犯隐私的内容该如何反馈？',
    a: '欢迎通过页面底部邮箱或投稿入口向编辑部反馈。我们设有审核机制，对存疑内容会加注说明或下架复核，涉及个人隐私与未成年人保护的内容会优先从严处理。',
  },
  {
    q: '如何把身边的热点线索投稿给平台？',
    a: '目前支持邮箱投稿，请在正文附上事件时间、地点、已知事实与可核实的信息来源（截图/链接）。编辑部会对线索做真实性评估，采用后会与投稿人确认信息来源口径。',
  },
  {
    q: '「吃瓜热点」的立场是什么？',
    a: '我们坚持「快、全、冷静」：快速跟进不等于煽动，内容追求客观呈现多方说法而非站队。我们反对网暴，拒绝夸大标题党，希望读者在获取猛料的同时也能保持独立思考。',
  },
];

export const sectionStats = [
  { num: '120+', label: '单日热点更新' },
  { num: '35万+', label: '累计追踪事件' },
  { num: '24h', label: '全时段滚动值班' },
  { num: '92%', label: '信源二次核验率' },
];